/**
 * Name of the DOM CustomEvent a host component fires when a consumer-supplied
 * (injected) toolbar button is clicked.
 */
export const INJECTED_BUTTON_CLICK_EVENT = 'injected-button-click';

/**
 * Detail payload of `INJECTED_BUTTON_CLICK_EVENT`.
 *
 * Note: `AbstractO2dElement.fireEvent` additionally stamps a `timestamp` onto the
 * emitted detail, so listeners observe `{ timestamp, id }` at runtime.
 */
export interface InjectedButtonClickEventDetail {
  /** The `id` of the clicked `InjectedButton` descriptor, passed through unchanged. */
  id: string;
}
